import { Screen } from '@/ui/core/screen'
import { View, useWindowDimensions } from 'react-native'

import { AppHeader } from '@/components/AppHeader'
import { AppNavigation } from '@/components/AppNavigation'
import { ProfileInfoForm } from '@/components/ProfilePage/ProfileInfoForm'
import ProtectedPage from '@/components/ProtectedPage'
import Logo, { LogoColorVariant } from '@/components/svgs/Logo'
import { HStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import Images from '#/assets/images/image-map'

const MobileProfileView = () => {
	return (
		<ProtectedPage>
			<AppHeader
				className="bg-transparent absolute"
				logoColor={LogoColorVariant.BRIGHT}
			/>
			<Image
				style={{
					height: 300,
					maxHeight: '33%',
					width: '100%',
				}}
				source={Images.ProfileHeadshot}
				contentFit="cover"
			/>
			<Screen
				preset="fixed"
				className="flex flex-1 w-full justify-center"
				contentContainerClassName="justify-center"
				StatusBarProps={{ style: 'light' }}
			>
				<View className="px-12">
					<ProfileInfoForm />
				</View>
			</Screen>
		</ProtectedPage>
	)
}

const DesktopProfileView = () => {
	return (
		<ProtectedPage>
			<View className="absolute z-30 pt-6 pl-12">
				<Logo color={LogoColorVariant.BRIGHT} />
			</View>
			<HStack fullHeight>
				<Image
					style={{
						width: '45%',
						height: '100%',
						zIndex: 10,
					}}
					source={Images.ProfileHeadshotLarge}
					contentFit="cover"
				/>
				<Image
					style={{
						width: 16,
					}}
					source={Images.VerticalDivider}
					contentFit="cover"
				/>
				<Screen preset="auto" className="flex flex-1">
					<HStack className="justify-end pt-6 pb-6 h-24 items-center">
						<AppNavigation />
					</HStack>
					<View className="flex flex-1 w-full justify-center">
						<View className="px-[20%] lg:px-[25%]">
							<ProfileInfoForm />
						</View>
					</View>
				</Screen>
			</HStack>
		</ProtectedPage>
	)
}

export default function SettingsScreen() {
	const { width } = useWindowDimensions()

	const showMobileView = width < 800

	return showMobileView ? <MobileProfileView /> : <DesktopProfileView />
}
